






































import Vue from "vue";
import Component from "vue-class-component";

import { Deck } from "../../types";

const DeckSelectionProps = Vue.extend({
  props: {
    decks: { type: Array as () => Deck[] },
    numberOfSelectedDecks: Number
  }
});

@Component
export default class DeckSelection extends DeckSelectionProps {
  get deckModel() {
    return this.decks
      .map(deck => (deck.selected ? deck.id : undefined))
      .filter(id => id !== undefined);
  }
  set deckModel(newModel) {
    this.decks.forEach(deck => {
      deck.selected = newModel.includes(deck.id);
    });
  }

  get selectedDeck() {
    return this.deckModel.length !== 1
      ? null
      : this.decks.find(deck => deck.id === this.deckModel[0]);
  }

  onButtonClick() {
    if (this.numberOfSelectedDecks === 0) {
      this.$router.push("add");
    } else {
      // start learning with selected decks
      this.$router.push("learn");
    }
  }
}
